<div class="h-100 pb-3">
  <div class="clinical-feedback-table custom-scrollbar h-100 px-3">
    <table
      mat-table
      matSort
      [dataSource]="dataSource"
      class="data-table table-fixed-head w-100"
      id="data-table"
      aria-label="List of studies"
    >
      <tr class="mat-row" *matNoDataRow>
        <td
          class="mat-cell text-center p-2"
          [colSpan]="displayedColumns.length"
        >
          <span>{{ displayTableMessage() }}</span>
        </td>
      </tr>

      <!-- patientMrn Column -->
      <ng-container matColumnDef="patientMrn">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by Patient MRN"
        >
          <div class="ml-2">MRN</div>
        </th>
        <td mat-cell *matCellDef="let row" class="p-2">
          <div class="ml-2">
            {{ row.patientMrn }}
          </div>
        </td>
      </ng-container>

      <!-- accessionNumber Column -->
      <ng-container matColumnDef="accessionNumber">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by Accession Number"
        >
          <div class="ml-2">Accession Number</div>
        </th>
        <td mat-cell *matCellDef="let row" class="p-2">
          <div class="ml-2">
            {{ row.trimmedAccessionNumber }}
          </div>
        </td>
      </ng-container>

      <!-- feedbackStatus Column -->
      <ng-container matColumnDef="feedbackStatus">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by Feedback Status"
        >
          <div class="ml-2">Feedback Status</div>
        </th>
        <td mat-cell *matCellDef="let row" class="p-2">
          <div class="ml-2">
            <div [ngClass]="getFeedbackStatusClass(row.feedbackStatus)">
              {{
                getFeedbackStatusValue(row.feedbackStatus) ??
                  clinicalFeedbackConstants.EMPTY_VALUE
              }}
            </div>
          </div>
        </td>
      </ng-container>

      <!-- feedbackType Column -->
      <ng-container matColumnDef="feedbackType">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by Feedback Type"
        >
          <div class="ml-2">Feedback Type</div>
        </th>
        <td mat-cell *matCellDef="let row" class="p-2">
          <div class="ml-2">
            <span *ngIf="row.feedbackType; else noFeedbackType">{{
              commonUtilities.getKeyValuePairData(
                feedbackTypeOptionList,
                row.feedbackType
              )
            }}</span>
            <ng-template #noFeedbackType>{{
              clinicalFeedbackConstants.EMPTY_VALUE
            }}</ng-template>
          </div>
        </td>
      </ng-container>

      <!-- feedbackSeriousIncidentType Column -->
      <ng-container matColumnDef="feedbackSeriousIncidentType">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by Feedback Sub-Type"
        >
          <div class="ml-2">Sub-Type</div>
        </th>
        <td mat-cell *matCellDef="let row" class="p-2">
          <div class="ml-2">
            <span
              *ngIf="
                row.feedbackSeriousIncidentType;
                else noSeriousIncidentType
              "
            >
              {{
                commonUtilities.getKeyValuePairData(
                  getRegionSeriousIncidentList(row.region),
                  row.feedbackSeriousIncidentType
                )
              }}</span
            >
            <ng-template #noSeriousIncidentType>{{
              clinicalFeedbackConstants.EMPTY_VALUE
            }}</ng-template>
          </div>
        </td>
      </ng-container>

      <!-- patientFirstName Column -->
      <ng-container matColumnDef="patientFirstName">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by Patient First Name"
        >
          <div class="ml-2">First Name</div>
        </th>
        <td mat-cell *matCellDef="let row" class="p-2">
          <div class="ml-2">
            <span *ngIf="row.patientFirstName; else noPatientFirstName">
              {{ row.patientFirstName }}
            </span>
            <ng-template #noPatientFirstName>{{
              clinicalFeedbackConstants.EMPTY_VALUE
            }}</ng-template>
          </div>
        </td>
      </ng-container>

      <!-- patientLastName Column -->
      <ng-container matColumnDef="patientLastName">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by Patient Last Name"
        >
          <div class="ml-2">Last Name</div>
        </th>
        <td mat-cell *matCellDef="let row" class="p-2">
          <div class="ml-2">
            <span *ngIf="row.patientLastName; else noPatientLastName">
              {{ row.patientLastName }}
            </span>
            <ng-template #noPatientLastName>{{
              clinicalFeedbackConstants.EMPTY_VALUE
            }}</ng-template>
          </div>
        </td>
      </ng-container>

      <!-- reportingRadiologist Column -->
      <ng-container matColumnDef="reportingRadiologist">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by Reporting Radiologist"
        >
          <div class="ml-2">Reporting Radiologist</div>
        </th>
        <td mat-cell *matCellDef="let row" class="p-2">
          <div class="ml-2">
            <span *ngIf="row.reportingRadiologist; else noReportingRadiologist">
              {{ row.reportingRadiologist }}
            </span>
            <ng-template #noReportingRadiologist>{{
              clinicalFeedbackConstants.EMPTY_VALUE
            }}</ng-template>
          </div>
        </td>
      </ng-container>

      <!-- Study Type Column -->
      <ng-container matColumnDef="studyType">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by Study Type"
        >
          <div class="ml-2">Study Type</div>
        </th>
        <td mat-cell *matCellDef="let row" class="p-2">
          <div class="ml-2">
            <span
              *ngIf="row.studyType; else noStudyType"
              [innerHTML]="encourageWrapping(row.studyType)"
            >
            </span>
            <ng-template #noStudyType>{{
              clinicalFeedbackConstants.EMPTY_VALUE
            }}</ng-template>
          </div>
        </td>
      </ng-container>

      <!-- Study Date Column -->
      <ng-container matColumnDef="studyDate">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by Study Date"
        >
          <div class="ml-2">Study Date</div>
        </th>
        <td mat-cell *matCellDef="let row" class="p-2">
          <div class="ml-2">
            <span *ngIf="row.studyDate; else noStudyDate">{{
              displayDateTime(row.studyDate)
            }}</span>
            <ng-template #noStudyDate>{{
              clinicalFeedbackConstants.EMPTY_VALUE
            }}</ng-template>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="action"
        ><th mat-header-cell *matHeaderCellDef class="p-0">
          <div class="mr-2 actions-header">Actions</div>
        </th>
        <td mat-cell *matCellDef="let row" class="p-0">
          <div class="actions">
            <button
              class="btn-raise-clinical-feedback"
              (click)="raiseClinicalFeedback($event, row)"
            >
              <fa-icon [icon]="['fas', 'comment-alt']"></fa-icon>
              <span>Raise Feedback</span>
            </button>
            <mat-form-field
              class="everlight-response"
              [ngClass]="{ disabled: row.everlightResponses.length === 0 }"
              floatLabel="never"
              aria-label="Clinical feedback everlight response"
            >
              <mat-select
                placeholder="Response"
                panelClass="response-panel"
                [disabled]="row.everlightResponses.length === 0"
                class="everlight-response-select"
                (click)="$event.stopPropagation()"
              >
                <mat-option
                  *ngFor="let everlightResponse of row.everlightResponses"
                  (click)="
                    downloadEverlightResponseDocument(
                      $event,
                      row.accessionNumber,
                      everlightResponse.documentId
                    )
                  "
                  >{{ everlightResponse.originalFileName }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>
        </td></ng-container
      >

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        [attr.data-clinical-feedback-id]="row.feedbackId"
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [ngClass]="getTableClass(row)"
        (click)="onDownloadFeedbackDocument(row)"
      ></tr>
    </table>
  </div>
</div>
